export const gitVersion = 'main-1.0.13-524-gd6564172';
